import { TipoFormaPagoEnumChoice } from "@/shared";
import { useFetchCalcularValorInstalacion, useFetchEntidadesFinancieras } from "@/shared/actions/erp";
import { useFetchCooperativa } from "@/shared/actions/erp/cooperativa.actions";
import { IFormaPago, IPaymentMethod, PaymentMethodEnum, TipoContratoENUM } from "@/shared/interfaces";
// import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CardValidator from "card-validator";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";

// import { useUiStore } from "@/store/ui";
// import { useNavigate } from "react-router-dom";
// import { useFetchPostSolicitudLiberacionValorInstalacion } from "@/shared/actions/erp/supervisor-liberacion-valor-instalacion";
// import { emailENUM } from "@/erp/sale/asesor";
// import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";

interface useFormPreventaCorporativaProps {
  preventa_corporativo_data: IPreventaCorporativoForm2,
  editSupervisor: boolean,
  // dataPreventaCorporativa?: IPreventaCorporativoForm2
}

export const useFormPreventaCorporativaServicio = (
  {
    preventa_corporativo_data,
    // editSupervisor,
    // dataPreventaCorporativa

  }: useFormPreventaCorporativaProps
) => {

  // const navigate = useNavigate()

  ///* state
  const [tipoTarjetaServicio, setTipoTarjeta] = useState<string | null>(null)
  const [visibleReferido, setVisibleReferido] = useState<boolean>(false)


  ///* formulario
  const formFormasPagosServicio = useForm<IFormaPago>({
    // resolver: yupResolver(newPreventaSchema)
  });


  const {
    reset,
    // setValue,
    setError,
    clearErrors
  } = formFormasPagosServicio

  ///* store

  ///* react query

  const {
    data: dataEntidadFinancieroServicio, isLoading: isLoadingEntidadFinancieroServicio
  } = useFetchEntidadesFinancieras({
    page_size: 600,
    enabled: formFormasPagosServicio.watch('codigo_forma_pago') == PaymentMethodEnum.TARJETA
  })

  const {
    mutateAsync: fetchCalcularValorInstalacion,
    isPending: isPendingValorInstalacion,
  } = useFetchCalcularValorInstalacion({
    enableSuccessAlert: false,
  });

  const { data: dataCooperativa, isLoading: isLoadingCooperativaServicio } =
    useFetchCooperativa({
      params: {
        entidad_financiera: formFormasPagosServicio.watch("entidad_financiera")!,
        estado: true,
      },
      enabled: !!formFormasPagosServicio.watch("entidad_financiera"),
    });



  ///* Handle


  const handleFormaPagoServicio = async (e: IPaymentMethod) => {
    setTipoTarjeta(null);
    reset({
      ...formFormasPagosServicio.getValues(),
      entidad_financiera: null,
      codigo_forma_pago: "",
      tipo_contrato: "",
      tarjeta: "",
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      // observacion_1: "",
    })

    try {

      if (e) {


        if (e.forma_pago == TipoFormaPagoEnumChoice.DEBITO) {
          formFormasPagosServicio.setValue("entidad_financiera", e.entidad_financiera)
        }
        const resp = await fetchCalcularValorInstalacion({
          id_prospecto_corporativo: preventa_corporativo_data?.id_prospecto_corporativo!,
          forma_pago: e.forma_pago,
          score: +preventa_corporativo_data?.puntaje_score_empresa!,
          segmentacion: preventa_corporativo_data?.segmentacion!,
        })
        const valueInstlacion = resp.data
        reset({
          ...formFormasPagosServicio.getValues(),
          // no_cobrar: false,
          codigo_forma_pago: e.forma_pago,
          tipo_contrato: e.tipo_contrato ?? TipoContratoENUM.GEDATECU,
          tarjeta: e.tarjeta,
          valor_instalacion_total: (
            (valueInstlacion?.valor_instalacion || 0) + (valueInstlacion?.iva || 0)
          ).toFixed(2),
          valor_instalacion: (valueInstlacion?.valor_instalacion.toFixed(2) || "0"), //valor sin iva
          valor_instalacion_iva: (
            (valueInstlacion?.valor_instalacion || 0) + (valueInstlacion?.iva || 0)
          ).toFixed(2),
          numero_cuenta: "",
          tipo_cuenta_bancaria: "",
          numero_tarjeta: "",
          tarjeta_fecha_caducidad:
            e.forma_pago !== PaymentMethodEnum.TARJETA
              ? null
              : formFormasPagosServicio.getValues().tarjeta_fecha_caducidad,
        });

      }

    } catch (error) {
      console.log('erro_', error);

    }


  }

  const handleValidarTarjeta = (numeroTarjeta: string) => {
    const numberValidation = CardValidator.number(numeroTarjeta)

    if (!numberValidation.isValid) {
      setTipoTarjeta("");
      setError("numero_tarjeta", {
        message: "Ingrear una tarjeta valida",
      });
    }
    if (numberValidation.isValid) {
      clearErrors("numero_tarjeta");
    }
    if (numberValidation.card) {
      setTipoTarjeta(numberValidation.card.type);
    }
  }

  useEffect(() => {
    formFormasPagosServicio.reset({
      forma_pago: preventa_corporativo_data?.forma_pago,
      tipo_contrato: preventa_corporativo_data?.tipo_contrato,
      codigo_forma_pago: preventa_corporativo_data?.codigo_forma_pago,
      entidad_financiera: preventa_corporativo_data?.entidad_financiera,
      tipo_cuenta_bancaria: preventa_corporativo_data?.tipo_cuenta_bancaria,
      cooperativa: preventa_corporativo_data?.cooperativa,
      numero_cuenta: preventa_corporativo_data?.numero_cuenta,
      tarjeta_fecha_caducidad: preventa_corporativo_data?.tarjeta_fecha_caducidad,
      numero_tarjeta: preventa_corporativo_data?.numero_tarjeta,
      tarjeta: preventa_corporativo_data?.tarjeta,
    })
  }, [])



  return {
    formFormasPagosServicio,


    // preventa_corporativo_data,
    ///* tab servicio
    handleFormaPagoServicio,
    isPendingValorInstalacion,
    dataCooperativaServicio: dataCooperativa?.data.data,
    isLoadingCooperativaServicio,
    handleValidarTarjeta,
    tipoTarjetaServicio,
    // handleSelectPlan,
    visibleReferido,
    setVisibleReferido,
    isLoadingEntidadFinancieroServicio,
    dataEntidadFinancieroServicio,

    ///* tab otros servicios
  }
}














export const useFormPreventaCorporativaInstalacion = (
  {
    preventa_corporativo_data,
    // editSupervisor,
    // dataPreventaCorporativa

  }: useFormPreventaCorporativaProps
) => {

  // const navigate = useNavigate()

  ///* state
  const [tipoTarjetaInstalacion, setTipoTarjeta] = useState<string | null>(null)


  ///* formulario
  const formFormasPagosInstalacion = useForm<IFormaPago>({
    // resolver: yupResolver(newPreventaSchema)
  });


  const {
    reset,
    // setValue,
    setError,
    clearErrors
  } = formFormasPagosInstalacion

  ///* store

  ///* react query

  const {
    data: dataEntidadFinancieroInstalacion, isLoading: isLoadingEntidadFinancieroInstalacion
  } = useFetchEntidadesFinancieras({
    page_size: 600,
    enabled: formFormasPagosInstalacion.watch('codigo_forma_pago') == PaymentMethodEnum.TARJETA
  })

  const {
    mutateAsync: fetchCalcularValorInstalacion,
    isPending: isPendingValorInstalacion,
  } = useFetchCalcularValorInstalacion({
    enableSuccessAlert: false,
  });

  const { data: dataCooperativa, isLoading: isLoadingCooperativaInstalacion } =
    useFetchCooperativa({
      params: {
        entidad_financiera: formFormasPagosInstalacion.watch("entidad_financiera")!,
        estado: true,
      },
      enabled: !!formFormasPagosInstalacion.watch("entidad_financiera"),
    });



  ///* Handle


  const handleFormaPagoInstalacion = async (e: IPaymentMethod) => {
    setTipoTarjeta(null);

    reset({
      ...formFormasPagosInstalacion.getValues(),
      entidad_financiera: null,
      codigo_forma_pago: "",
      tipo_contrato: "",
      tarjeta: "",
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      // observacion_1: "",
    })
    if (e) {
      if (e.forma_pago == TipoFormaPagoEnumChoice.DEBITO) {
        formFormasPagosInstalacion.setValue("entidad_financiera", e.entidad_financiera)
      }

      const resp = await fetchCalcularValorInstalacion({
        id_prospecto_corporativo: preventa_corporativo_data?.id_prospecto_corporativo!,
        forma_pago: e.forma_pago,
        score: +preventa_corporativo_data?.puntaje_score_empresa!,
        segmentacion: preventa_corporativo_data?.segmentacion!,
      })

      const valueInstalacion = resp.data
      reset({
        ...formFormasPagosInstalacion.getValues(),
        // no_cobrar: false,
        codigo_forma_pago: e.forma_pago,
        tipo_contrato: e.tipo_contrato ?? TipoContratoENUM.GEDATECU,
        tarjeta: e.tarjeta,
        valor_instalacion_total: (
          (valueInstalacion?.valor_instalacion || 0) + (valueInstalacion?.iva || 0)
        ).toFixed(2),
        valor_instalacion: valueInstalacion?.valor_instalacion.toFixed(2) || "0", //valor sin iva
        valor_instalacion_iva: (
          (valueInstalacion?.valor_instalacion || 0) + (valueInstalacion?.iva || 0)
        ).toFixed(2),
        numero_cuenta: "",
        tipo_cuenta_bancaria: "",
        numero_tarjeta: "",
        tarjeta_fecha_caducidad:
          e.forma_pago !== PaymentMethodEnum.TARJETA
            ? null
            : formFormasPagosInstalacion.getValues().tarjeta_fecha_caducidad,
      });
      return
    }


  }

  const handleValidarTarjeta = (numeroTarjeta: string) => {
    const numberValidation = CardValidator.number(numeroTarjeta)

    if (!numberValidation.isValid) {
      setTipoTarjeta("");
      setError("numero_tarjeta", {
        message: "Ingrear una tarjeta valida",
      });
    }
    if (numberValidation.isValid) {
      clearErrors("numero_tarjeta");
    }
    if (numberValidation.card) {
      setTipoTarjeta(numberValidation.card.type);
    }
  }

  useEffect(() => {
    formFormasPagosInstalacion.reset({
      forma_pago: preventa_corporativo_data?.forma_pago,
      tipo_contrato: preventa_corporativo_data?.tipo_contrato,
      codigo_forma_pago: preventa_corporativo_data?.codigo_forma_pago,
      entidad_financiera: preventa_corporativo_data?.entidad_financiera,
      tipo_cuenta_bancaria: preventa_corporativo_data?.tipo_cuenta_bancaria,
      cooperativa: preventa_corporativo_data?.cooperativa,
      numero_cuenta: preventa_corporativo_data?.numero_cuenta,
      tarjeta_fecha_caducidad: preventa_corporativo_data?.tarjeta_fecha_caducidad,
      numero_tarjeta: preventa_corporativo_data?.numero_tarjeta,
      tarjeta: preventa_corporativo_data?.tarjeta,
    })
  }, [])


  return {
    formFormasPagosInstalacion,


    // preventa_corporativo_data,
    ///* tab servicio
    handleFormaPagoInstalacion,
    isPendingValorInstalacion,
    dataCooperativaInstalacion: dataCooperativa?.data.data,
    isLoadingCooperativaInstalacion,
    handleValidarTarjeta,
    tipoTarjetaInstalacion,
    isLoadingEntidadFinancieroInstalacion,
    dataEntidadFinancieroInstalacion,

    ///* tab otros servicios
  }
}